import styled from '@emotion/styled';

export const PortaledMenuWrapper = styled.div`
  position: absolute;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
`;
